import React, { useContext, useEffect } from 'react'
import { ConfigContext } from '../../contexts/ConfigContext';
import { IonButton, IonIcon } from '@ionic/react';
import { print } from 'ionicons/icons';
import BalanceReportPattern from './BalanceReportPattern';
import moment from 'moment';
import db from '../../resources/db';
import { getBalanceCreditDebit } from '../../resources/Hooks';

const BalanceReport = () => {
    const { getCompany, getCustomerList } = useContext(ConfigContext);
    const [Company, setCompany] = React.useState({});
    const [CustomerList, setCustomerList] = React.useState([]);

    useEffect(() => {
        getCompany().then(res => {
            setCompany(res);
        });
        getCustomerList().then(res => {
            setCustomerList(res);
        });
        return () => {
            setCompany({});
            setCustomerList([]);
        }
    }, [getCompany, getCustomerList]);
            

    function generateReport() {

        let legers = []
        let customersData = CustomerList.map(async (name) => {
            let customer = await db.ledger.where("customerName").equals(name).toArray();
            let { balance, credit, debit } = getBalanceCreditDebit(customer);
            legers.push(...customer)
            return { credit, debit, balance, name };
        });
        Promise.all(customersData).then(customers => {
            customers = customers.filter((c) => (c.balance > 1))
            let total = getBalanceCreditDebit(customers);
            printReport(customers, total);
        })
    }

    const printReport = (customers, total) => {
        let report = {
            companyName: Company.name,
            companyAddress: Company.address,
            companyContact: Company.contact,
            gst: Company.gst,
            billDate: moment(Date()).format('ll'),
            customers,
            total,
        }

        console.log(report);
        let print = document.getElementById("print").contentWindow;
        print.document.write(BalanceReportPattern(report));
        print.document.close();
        print.focus();
        print.print();
    }
    return (
        <div>
            <IonButton onClick={() => {
                generateReport();
            }} color='primary'>
                <IonIcon size='start' icon={print} />
                Balance Report
            </IonButton>
            <iframe className="ion-hide" id="print" title="Print Invoice"></iframe>
        </div>

    )
}

export default BalanceReport


